import React, { CSSProperties } from 'react';
import useTranslate from '../../../../customHooks/useTranslate';
import { supplierTaxCalculationTypesIcons } from '../../../../utils/taxes/taxesListUtils';
import Tooltip from '../../../../muiComponents/Tooltip';
import Icon from '../../../../muiComponents/Icon';

interface ISupplierTaxCalculationTypeIconProps {
    entityKey: string;
    text: string;
    color: string;
}

const SupplierTaxCalculationTypeIcon = ({
    entityKey,
    text,
    color,
}: ISupplierTaxCalculationTypeIconProps) => {
    const translate = useTranslate();
    const supplierTaxCalculationTypeIcon =
        supplierTaxCalculationTypesIcons[
            entityKey as keyof typeof supplierTaxCalculationTypesIcons
        ];

    const outlinedStyles: CSSProperties = {
        color,
        backgroundColor: 'transparent',
        border: `1px solid ${color}`,
    };

    return (
        <Tooltip title={`${translate('calculation_type')}: ${text || ''}`}>
            <div
                className='flex gap-5 flex-align-center tag__container'
                style={outlinedStyles}
            >
                <Icon iconName={supplierTaxCalculationTypeIcon} />
                <p style={{ fontWeight: 600, fontSize: '12px' }}>{text}</p>
            </div>
        </Tooltip>
    );
};

export default SupplierTaxCalculationTypeIcon;
